import React from 'react';
// import PropTypes from 'prop-types';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as schemeDocumentsActions from '../actions/schemesDocumentsActions';
import { SchemeDocumentsEditFormCard } from '../components/SchemeDocumentsFormCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

class SchemesDocumentDetailScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_SCHEMES,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_SCHEMES_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.schemeDocumentsActions.getSchemaDocument(id);
    }

    componentDidUpdate(prevProps, prevState) {
        const { schema: currentSchema, location } = this.props;
        const { schema: prevSchema } = prevProps;

        if ( currentSchema !== prevSchema && currentSchema ) {
            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_SCHEMES_DETAIL.id,
                url: location.pathname,
                description: currentSchema.name,
            });

            this.setState({
                breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
            });
        }
    }

    render() {
        const { schema } = this.props;
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MI_ESQUEMA_DE_DOCUMENTO')} breadcrumbs={breadcrumbs}>
                {
                    schema ? (
                        <SchemeDocumentsEditFormCard schemeDocument={this.props.schema}/>
                    ) : null
                }
            </PsPage>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        schema: state.schemeDocuments.schemeDocuments[ownProps.match.params.id],
    };
};

const mapDispatchToProps = dispatch => ( {
    schemeDocumentsActions: bindActionCreators(schemeDocumentsActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(SchemesDocumentDetailScreen);

SchemesDocumentDetailScreen.propTypes = {};

SchemesDocumentDetailScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/screens/SchemesDocumentDetailScreen.js